<template>
  <div class="progress-bar-container">
    <div class="progress"
      :style="{
        width: progress + '%',
        background: 'var(--linear-2-paints,linear-gradient(90deg,rgba(126, 180, 235, 1) 0%,rgba(177, 110, 249, 1) 100%))'
      }"></div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 100
    }
  }
}
</script>

<style scoped>
.progress-bar-container {
  width: 100%;
  height: 5px;
  background: rgba(101, 101, 135, 0.1);
  border-radius: 3px;


  overflow: hidden;
}

.progress {
  height: 100%;
  transition: width 0.5s ease;
  /* 可选：为进度变化添加动画效果 */
}
</style>